import { IconButton, IconName } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { useDeleteCentralPaymentPolicyDialog } from '../../hooks';

export const HeaderActions = ({
    isAssignedToRateGroups,
    handleCloseSidePanel,
    paymentPolicyId,
}: {
    isAssignedToRateGroups: boolean;
    handleCloseSidePanel: () => void;
    paymentPolicyId: string;
}) => {
    const { confirmationDialog, openConfirmationDialog } = useDeleteCentralPaymentPolicyDialog({
        onSuccess: handleCloseSidePanel,
        paymentPolicyId,
        isAssignedToRateGroups,
    });

    return (
        <>
            <IconButton
                data-test-id={DataTestId.DeletePaymentPolicy}
                icon={IconName.Delete}
                onClick={openConfirmationDialog}
                size="small"
                type="submit"
            />
            {confirmationDialog}
        </>
    );
};
